import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import CardLlamada from './CardLlamada';
import './Llamada.css'
import Cale from './Cale';

function Llamada() {
  return (
    <Container className=''>
        <Row>        
            <Col className='col-12'>
                {/* <h5 className='pretituloLlamada'>Lorem Ipsum Dolor</h5> */}
                <h4 className='tituloBlancoLlamada'>Hablemos <span className='tituloAzulLlamada'>30 </span> minutos</h4>
            </Col>
        </Row>
        <Row>
            <Col className='col-sm-12 col-md-6'>
                <div className='contenedorTildes'>
                    <p className='parrafoTildes'>Te voy a comentar el embudo de ventas con el que trabajaremos y cómo ejecutaremos este plan de acción en tu empresa.</p>
                    {/* <CardLlamada texto={"Sienten que tocaron techo."}/>
                    <CardLlamada texto={"Quieren aumentar su facturación con un sistema de ventas rentable."}/>
                    <CardLlamada texto={"Esten cansados de trabajar con agencias o CM que les prometen pero no les logran nada."}/>
                    <CardLlamada texto={"Quieren crecer rápidamente con ADS."}/>
                    <CardLlamada texto={"Quieren llevar su negocio al máximo potencial asegurado."}/> */}
                </div>
            </Col>
        </Row>
        <Row>
            <Col className='col-sm-12 col-md-12'>
                <div className='calendly'>
                    <Cale/>
                </div>
            </Col>
        </Row>
    </Container>
  )
}

export default Llamada
